(function (angular, document) {
  "use strict";

  angular.module("Toyota.Services").service("CustomEvents", [
    function () {
      const exports = this;

      exports.createDispatcherAndListener = (eventName) => ({
        dispatch: (detail) => {
          const newCustomEvent = new CustomEvent(eventName, { detail });
          document.dispatchEvent(newCustomEvent);
        },
        listener: (handler) => {
          if (typeof window?.document !== "undefined") {
            document.addEventListener(eventName, handler);

            return () => document.removeEventListener(eventName, handler);
          }

          // eslint-disable-next-line no-empty-function
          return () => {};
        },
      });

      return exports;
    },
  ]);
})(window.angular, window.document);
